import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@/main'
import { EmailGallery, EmailGalleryBoundary, EmailGallerySkeleton } from './-components/dev-resources/email-gallery'

export const Route = createFileRoute('/_app/dev-resources/emails')({
  loader: ({ context }) => {
    context.queryClient.prefetchQuery(trpc.admin.listEmailTemplates.queryOptions())
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <section className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-xl font-semibold">Email templates</h2>
        <p className="text-muted-foreground text-sm">
          The rendering here is the exact output that gets sent, snapshotted in{' '}
          <code className="text-xs">catalog.unit.test.ts</code> (a unit test fails if a template changes unexpectedly;
          run <code className="text-xs">pnpm test -u</code> to accept changes).
        </p>
      </div>
      <EmailGalleryBoundary>
        <Suspense fallback={<EmailGallerySkeleton />}>
          <EmailGallery />
        </Suspense>
      </EmailGalleryBoundary>
    </section>
  )
}
